import { render, staticRenderFns } from "./ViewPackage.vue?vue&type=template&id=72ccde6a&"
import script from "./ViewPackage.vue?vue&type=script&lang=js&"
export * from "./ViewPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports